import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M14.195 2.842c-.976-1.69-3.416-1.69-4.392 0l-8.46 14.652c-.976 1.69.244 3.804 2.196 3.804h16.92c1.952 0 3.172-2.113 2.196-3.804zm-2.928.845a.845.845 0 0 1 1.464 0l8.46 14.652a.845.845 0 0 1-.732 1.268H3.539a.846.846 0 0 1-.732-1.268zm-.112 10.037V8.968a.845.845 0 0 1 1.69 0v4.756a.845.845 0 0 1-1.69 0m.845 1.86A1.014 1.014 0 1 1 12 17.612 1.014 1.014 0 0 1 12 15.584",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }